import { EmptyBox, FlexRow, FlexRowBetween, LoaderDataBox } from 'components'
import { GetInspectionReport, useNotification, useQueryString } from 'hooks'
import { GroupListModal, AnalyzeWithAIModal } from 'page-components'
import { CustomerEmailModal } from 'page-components/customer/CustomerEmailModal'
import {
    EmailHistoryPanel,
    EmailHistoryToolbarButton,
    useAuditEmailHistory,
} from 'page-components/report/EmailHistoryPanel'
import { CaretLeft, ShareNetwork, Robot, Envelope } from 'phosphor-react'
import React, { useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Header } from 'semantic-ui-react'
import styled from 'styled-components'
import { InspectionService, QueryString, ReportText } from 'utility'
import { DesktopMode, MobileMode } from 'layout'

const ReportContainer = styled.div`
    .i-frame {
        height: 85vh;
    }
    .mobile-header {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .mobile-actions {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-top: 8px;
    }
`

export const InspectionReportScreen = () => {
    const { id } = useParams()
    const query = useQueryString()
    const location = useLocation()
    const customeReport = query.get(QueryString.customeReport)
    const isCumulative = query.get('cumulative') === 'true'
    const cumulativeData = location.state?.reportData
    // Only call API if not cumulative report
    const { data: apiData, loading: apiLoading } = GetInspectionReport(
        isCumulative ? null : id,
        customeReport,
    )
    const { successToast } = useNotification()
    const navigation = useNavigate()
    const [openGroupModal, setOpenGroupModal] = useState(false)
    const [openAI, setOpenAI] = useState(false)
    const [openEmailModal, setOpenEmailModal] = useState(false)
    const emailHistory = useAuditEmailHistory(id)

    const closeEmailModal = shouldRefresh => {
        setOpenEmailModal(false)
        if (shouldRefresh) emailHistory.refresh()
    }

    // Use Cumulative API data if available, otherwise use regular API data
    const data = isCumulative && cumulativeData ? cumulativeData : apiData
    const loading = isCumulative && cumulativeData ? false : apiLoading

    const onCloseShareGroup = async (list) => {
        try {
            if (list.length) {
                await InspectionService.shareReport({ ReportId: data.Id, GroupId: list.toString() })
                successToast(ReportText.sharedToGroup)
            }
        } finally {
            setOpenGroupModal(false)
        }
    }

    return (
        <ReportContainer className="mt-5">
            <DesktopMode>
                <Header as="h4" block>
                    <FlexRowBetween>
                        <FlexRow onClick={() => navigation("/app/task")} className="align-items-center pointer">
                            <CaretLeft size="24" />
                            <div className="ms-2">Home</div>
                        </FlexRow>
                        <FlexRow className="align-items-center flex-wrap justify-content-end">
                            <FlexRow onClick={() => setOpenAI(true)} className="align-items-center pointer me-3">
                                <Robot />
                                <div className="ms-2">Analyze with AI</div>
                            </FlexRow>
                            <FlexRow onClick={() => setOpenEmailModal(true)} className="align-items-center pointer me-3">
                                <Envelope />
                                <div className="ms-2">Send Email</div>
                            </FlexRow>
                            <EmailHistoryToolbarButton
                                totalCount={emailHistory.totalCount}
                                historyAvailable={emailHistory.historyAvailable}
                                onClick={() => emailHistory.setOpen(true)}
                            />
                            <FlexRow onClick={() => setOpenGroupModal(true)} className="align-items-center pointer">
                                <ShareNetwork />
                                <div className="ms-2">Share to Group</div>
                            </FlexRow>
                        </FlexRow>
                    </FlexRowBetween>
                </Header>
                {!loading && !data?.ReportPath && <EmptyBox />}
                {loading && !data?.ReportPath && <LoaderDataBox />}
                {data?.ReportPath && <div className="mt-3">
                    <iframe src={data.ReportPath} width="100%" className="i-frame" title="Report" />
                </div>}
                <GroupListModal open={openGroupModal} onClose={onCloseShareGroup} />
                <AnalyzeWithAIModal open={openAI} onClose={() => setOpenAI(false)} item={data} />
                <CustomerEmailModal
                    open={openEmailModal}
                    onClose={closeEmailModal}
                    reportId={data?.Id}
                />
            </DesktopMode>
            <MobileMode>
                <div className="mobile-header">
                    <FlexRow onClick={() => navigation("/app/task")} className="align-items-center pointer">
                        <CaretLeft size="24" />
                        <div className="ms-2">Home</div>
                    </FlexRow>
                    <div className="mobile-actions">
                        <FlexRow onClick={() => setOpenAI(true)} className="align-items-center pointer">
                            <Robot />
                            <div className="ms-2">Analyze with AI</div>
                        </FlexRow>
                        <FlexRow onClick={() => setOpenEmailModal(true)} className="align-items-center pointer">
                            <Envelope />
                            <div className="ms-2">Send Email</div>
                        </FlexRow>
                        <EmailHistoryToolbarButton
                            block
                            totalCount={emailHistory.totalCount}
                            historyAvailable={emailHistory.historyAvailable}
                            onClick={() => emailHistory.setOpen(true)}
                        />
                        <FlexRow onClick={() => setOpenGroupModal(true)} className="align-items-center pointer">
                            <ShareNetwork />
                            <div className="ms-2">Share to Group</div>
                        </FlexRow>
                    </div>
            </div>
                {!loading && !data?.ReportPath && <EmptyBox />}
                {loading && !data?.ReportPath && <LoaderDataBox />}
                {data?.ReportPath && <div className="mt-3">
                    <iframe src={data.ReportPath} width="100%" className="i-frame" title="Report" />
                </div>}
                <GroupListModal open={openGroupModal} onClose={onCloseShareGroup} />
                <AnalyzeWithAIModal open={openAI} onClose={() => setOpenAI(false)} item={data} />
                <CustomerEmailModal
                    open={openEmailModal}
                    onClose={closeEmailModal}
                    reportId={data?.Id}
                />
            </MobileMode>
            <EmailHistoryPanel
                open={emailHistory.open}
                auditId={id}
                refreshKey={emailHistory.refreshKey}
                knownTotal={emailHistory.totalCount}
                onClose={() => emailHistory.setOpen(false)}
                onMeta={emailHistory.setMeta}
            />
        </ReportContainer>
    )
}
